<template>
  <div>
    <Errors :errors="additionErrors" />

    <div class="cms-content capped-md">
      <span v-if="currentSite === 'inboedelopslag'">
        Mocht u extra informatie hebben die nuttig is voor deze aanvraag of heeft u een vraag dan kunt u die hieronder kwijt.
      </span>

      <span v-else>
        Extra informatie over uw verhuizing. Omschrijf hier alle nuttige informatie die belangrijk is voor het verwerken van uw aanvraag!
        Denk bijvoorbeeld aan type woning, bereikbaarheid, bijzondere meubelstukken of omstandigheden.
      </span>
    </div>

    <fieldset class="form-fieldset mt-3 mt-lg-4">
      <legend class="form-legend intake__heading mb-2">
        Extra informatie
      </legend>

      <div v-if="currentSite === 'inboedelopslag'">
        <div class="mb-2">
          {{ i18n.test }}
        </div>

        <div class="row">
          <div v-for="container in formattedContainers" class="reserve-container reserve-container--card col-md-3 mb-3">
            <input
              type="radio"
              :id="`container-${container.key}`"
              :value="container.key"
              name="container"
              :checked="addition.container === container.key"
              @change="(e) => updateAdditionsField(['container', e.target.value])"
            >

            <label :for="`container-${container.key}`">
              {{ container.amount }} container ({{ container.cubic_metres }} m³)<br>
              €{{ container.price_with_tax }},- per maand
            </label>

          </div>
        </div>
      </div>

      <div class="bg-white p-2">
        <div class="row row--tight-gutters">
          <div class="col-md-6">
            <div class="form-group mb-0" id="addition-wrapper">
              <label for="addition">
                Toelichting
              </label>

              <textarea
                class="form-control"
                id="addition"
                :value="addition.addition"
                rows="6"
                @input="(e) => updateAdditionsField(['addition', e.target.value])"
              ></textarea>
            </div>
          </div>

          <div class="col-md-6">
            <div v-if="objects && objects.length">
              <h2 class="mb-2">Geselecteerde items</h2>
              <div class="row">
                <div v-for="(object) in objects" v-if="object.count > 0" class="col-md-6">
                  <div class="d-flex justify-content-between bg-gray p-2 mb-3">
                    <span>{{ object.title }}</span>
                    <span>{{ object.count }}x</span>
                  </div>
                </div>
              </div>

              Totale ruimte nodig: <strong>{{ totalCubicMetres }}m<sup>3</sup></strong>
            </div>
          </div>
        </div>
      </div>
    </fieldset>

    <button
      class="btn btn--primary mt-3"
      :class="{ 'has-errors': hasErrors, }"
      type="button"
      @click="() => submit()"
      :disabled="isLoading"
    >
      {{ isLoading ? 'Moment a.u.b.' : 'Versturen' }}

      <span class="btn__error-icon">
        <Icon name="exclamation" />
      </span>
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Errors from '@/intake/components/Errors.vue';
import Icon from '@/intake/components/Icon.vue';

export default {
  components: {
    Errors,
    Icon,
  },

  computed: {
    ...mapGetters({
      isLoading: 'isLoading',
      addition: 'addition/additions',
      clientErrors: 'clientErrors',
      addressErrors: 'addressErrors',
      roomErrors: 'roomErrors',
      additionErrors: 'additionErrors',
      objects: 'room/objects',
      totalCubicMetres: 'room/totalCubicMetres',
      currentSite: 'currentSite',
      containers: 'containers',
      i18n: 'i18n',
    }),

    formattedContainers() {
      return Object.entries(this.containers)?.map(([index, container]) => {
        return {
          key: parseFloat(index),
          ...container,
        }
      }).sort((a, b) => {
        return a.key - b.key;
      });
    },

    hasErrors() {
      if (this.currentSite === 'inboedelopslag') {
        return (
          this.clientErrors && this.clientErrors.length
          || this.roomErrors && this.roomErrors.length
          || this.additionErrors && this.additionErrors.length
        );
      }

      return (
        this.clientErrors && this.clientErrors.length
        || this.addressErrors && this.addressErrors.length
        || this.roomErrors && this.roomErrors.length
        || this.additionErrors && this.additionErrors.length
      );
    },
  },

  methods: {
    ...mapActions({
      submit: 'submit',
    }),

    ...mapMutations({
      updateAdditionsField: 'addition/updateAdditionsField',
    }),
  },
};
</script>
